import React, { Suspense, lazy } from 'react';
const GamePage = lazy(() => import('./pages/GamePage').then(m => ({
  default: m.GamePage
})));
export function App() {
  return <Suspense fallback={<div className="min-h-screen bg-[#020510] flex items-center justify-center" data-id="element-1">
          <span className="text-[#006600] text-xs tracking-[4px] font-['Share_Tech_Mono',monospace]" data-id="element-2">
            &gt; CARGANDO...
          </span>
        </div>} data-id="element-0">
      <GamePage data-id="element-3" />
    </Suspense>;
}